<template>
	<el-container>
		<Menu :activeIndex='activeIndex'></Menu>
		<el-container>
			<el-header>
				<h2>系统图片管理</h2>
			</el-header>
			<el-main>
				<!-- 表格 -->
				<el-table :data="tableData" style="width: 100%;" :stripe="true" :border='true' :default-sort="{prop: 'date', order: 'descending'}">

					<el-table-column prop="name" label="名称" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="url" label="图片" style="">
						<template slot-scope="scope">
							<img :src="scope.row.url" alt="" style="width: 100px;margin-top:5px;">
						</template>
					</el-table-column>

					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="primary" size="mini" plain @click="handleEdit(scope.$index, scope.row),dialogBannerVisible = true">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-main>
			<el-footer>Copyright &copy; Soren经济学人 技术支持 ：
				<a href="#">苏州西西弗斯商务信息咨询有限公司</a>
			</el-footer>
		</el-container>
		<el-dialog title="图片编辑" :visible.sync="dialogBannerVisible">

			<el-form :model="form">
				<el-form-item label="名称" :label-width="formLabelWidth">
					<el-input v-model="form.name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="图片" :label-width="formLabelWidth">
					<el-upload class="avatar-uploader" :action="UploadUrl()" :http-request='submitLogoUpload' :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<img v-if="form.url" :src="form.url" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogBannerVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogBannerVisible = false,submitbanner(form)">确 定</el-button>
			</div>
		</el-dialog>
	</el-container>


</template>

<script>
	export default {
		data() {
			return {
				activeIndex: "3",
				tableData: [],
				formLabelWidth: "150px",
				dialogBannerVisible: false,
				form: {
					mark: localStorage.getItem("mark"),
					name: "",
					url: "",
					id: ""
				}
			};
		},
		created() {
			this.getData();
		},
		updated: function() {
			this.ifHavemark();
		},

		methods: {
			// 页面 表格数据 初始化
			getData() {
				var self = this;
				self.axios.post("/bkg/list",{
					mark: localStorage.getItem("mark")
				})
				.then(function(response) {
					if(response.data.code == "600") {} else if(response.data.code == "400") {
						self.$message({
							type: "error",
							message: "操作失败"
						});
					} else {
						self.ifLogin();
					}
					console.log(response);
					self.tableData = response.data.data;
				})
				.catch(function(error) {
					console.log(error);
				});
			},
			submitLogoUpload(content) {
				console.log(content);
				var self = this;
				//1. 创建formData 利用AXIOS传递
				let formData = new FormData();
				formData.append("file", content.file);
				let config = {
					"Content-Type": "multipart/form-data"
				};
				let var_this = this;
				self.axios
					.post("/file/uploadLogo", formData, config)
					.then(function(response) {
						console.log(response);
						self.form.url = response.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			//form 表单 数据
			submitbanner(formName) {
				console.log(formName);
				var self = this;
				self.axios.post("/bkg/add",formName)
				.then(function(response) {
					if(response.data.code == "600") {} else if(response.data.code == "400") {
						self.$message({
							type: "error",
							message: "操作失败"
						});
					} else {
						self.ifLogin();
					}
					//console.log(response);
					self.$message({
						message: "添加/编辑成功",
						type: "success"
					});
					self.getData();
				})
				.catch(function(error) {
					console.log(error);
				});
			},
			handleEdit(index, row) {
				var self = this;
				self.form.name = row.name;
				self.form.url = row.url;
				self.form.id = row.id;
			},
			handleAvatarSuccess(res, file) {
				console.log(res, file);
				this.form.src = res.data;
			},
//			beforeAvatarUpload(file) {
//				const isJPG = file.type === "image/jpeg";
//				const isLt2M = file.size / 1024 / 1024 < 2;
//
//				if(!isJPG) {
//					this.$message.error("上传头像图片只能是 JPG 格式!");
//				}
//				if(!isLt2M) {
//					this.$message.error("上传头像图片大小不能超过 2MB!");
//				}
//				return isJPG && isLt2M;
//			},
			beforeAvatarUpload: function(file) {
				var that = this;
				const isJPG = file.type === 'image/jpeg';
				const isGIF = file.type === 'image/gif';
				const isPNG = file.type === 'image/png';
				const isBMP = file.type === 'image/bmp';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if(!isJPG && !isGIF && !isPNG && !isBMP) {
					that.$message({
						message: '上传图片必须是JPG/GIF/PNG/BMP 格式!',
						type: 'warning'
					});
				}
				if(!isLt2M) {
					that.$message({
						message: 's F上传图片大小不能超过 2MB!',
						type: 'warning'
					});
				}
				return(isJPG || isBMP || isGIF || isPNG) && isLt2M;
			},
			UploadUrl: function() {
				return "https://console.sorenenglish.com/file/uploadLogo";
			},
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.el-header {
		position: relative;
	}

	.el-header h2 {
		margin: 0;
		line-height: 60px;
	}

	.el-header #btn_add {
		position: absolute;
		right: 25px;
		top: 12px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #67c23a;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px !important;
		text-align: center;
	}

	.avatar {
		width: 100%;
		height: auto;
		display: block;
	}

	.Saveid {
		cursor: pointer;
		color: #67c23a;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/components/system.vue